module.exports = __webpack_public_path__ + "media/categories/7015-96bd1d3b.svg";